import { SET_DELETECAR } from '../actions';

const deletecar = (state = [], action) => {
  switch (action.type) {
	case SET_DELETECAR:
      return [...action.value];  
    default: return state;
  }
}

export default deletecar;
